// Utilidades del catálogo de proyectos (C3D-38), compartidas por el panel, el
// enlace público y el perfil del usuario.

const euro = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });

/** "2,10 €" a partir del texto decimal que manda la API. */
export const formatPrice = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? euro.format(amount) : '';
};

/** "Desde 50 uds" / "1 ud" para la fila de un tramo. */
export const tierLabel = (minQuantity) => (
    Number(minQuantity) <= 1 ? 'Desde 1 ud' : `Desde ${minQuantity} uds`
);

/** Enlace de WhatsApp con el texto ya escrito; sin teléfono, deja elegir contacto. */
export const whatsappUrl = (phone, text) => {
    const digits = String(phone || '').replace(/\D/g, '');
    const query = `text=${encodeURIComponent(text)}`;
    return digits ? `https://wa.me/${digits}?${query}` : `https://wa.me/?${query}`;
};

/** Texto con el que el lead pregunta por un modelo concreto. */
export const itemEnquiryText = (catalogName, item) => (
    `Hola, he visto "${item.title}" en el catálogo "${catalogName}" (ref. ${item.id}) y quiero más información.`
);

/** Texto con el que el comercial manda el enlace del catálogo. */
export const shareCatalogText = (customerName, catalogName, url) => (
    customerName
        ? `Hola ${customerName}, te paso el catálogo "${catalogName}" con los modelos que hemos preparado para ti. Puedes verlos en 3D aquí: ${url}`
        : `Te paso el catálogo "${catalogName}". Puedes ver los modelos en 3D aquí: ${url}`
);

export const PROJECT_STATUS_OPTIONS = [
    { value: 'borrador', label: 'Borrador' },
    { value: 'enviado', label: 'Enviado' },
    { value: 'en_negociacion', label: 'En negociación' },
    { value: 'ganado', label: 'Ganado' },
    { value: 'perdido', label: 'Perdido' },
];

export const PROJECT_STATUS_TONE = {
    borrador: 'neutral',
    enviado: 'info',
    en_negociacion: 'warning',
    ganado: 'success',
    perdido: 'error',
};

export const projectStatusLabel = (value) => (
    PROJECT_STATUS_OPTIONS.find((option) => option.value === value)?.label || value
);

// Si nos ha comprado (automático), se marcó a mano o sigue siendo lead.
export const CUSTOMER_STATE = {
    cliente: { label: 'Cliente', tone: 'success', title: 'Tiene un pedido pagado' },
    cliente_manual: { label: 'Cliente', tone: 'info', title: 'Marcado como cliente a mano' },
    lead: { label: 'Lead', tone: 'neutral', title: 'Todavía no nos ha comprado' },
};

/** URL pública del catálogo en esta web. */
export const catalogPublicUrl = (token) => `${window.location.origin}/catalogo/${token}`;

export const PRODUCT_TYPE_FILTERS = [
    { value: '', label: 'Todos los tipos' },
    { value: 'keyring', label: 'Llavero' },
    { value: 'coaster', label: 'Posavasos' },
    { value: 'napkin_bubble', label: 'Servilletero BUBBLE' },
    { value: 'napkin_panel', label: 'Servilletero de paredes' },
    { value: 'lightbox', label: 'Caja de luz LED' },
];
